const companyNews = [
    {
      title: "Quarterly Earnings Report Exceeds Expectations",
      content: "The company’s earnings for Q3 have surpassed expectations, with a 20% increase in revenue...",
      imageUrl: "https://images.unsplash.com/photo-1593642532400-2682810df593?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-01-15",
    },
    {
      title: "New Office Opening in Nairobi",
      content: "We are excited to announce the opening of our new branch in Nairobi, further expanding our presence in Africa...",
      imageUrl: "https://images.unsplash.com/photo-1581091870627-3d88d6ba6828?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-02-02",
    },
    {
      title: "CEO Wins Industry Leadership Award",
      content: "Our CEO has been recognized for outstanding leadership at the annual Tech Innovators Gala...",
      imageUrl: "https://images.unsplash.com/photo-1526948128573-703ee1aeb6fa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-03-05",
    },
    {
      title: "Product Line Expansion: Introducing New Solutions",
      content: "The company has unveiled three new products aimed at boosting customer experience...",
      imageUrl: "https://images.unsplash.com/photo-1519337265831-281ec6cc8514?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-04-10",
    },
    {
      title: "Employee Wellness Program Launched",
      content: "We’ve launched a comprehensive wellness program that includes mental health support and fitness initiatives...",
      imageUrl: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-05-12",
    },
    {
      title: "Partnership with Local Universities Announced",
      content: "The company has partnered with leading universities to foster talent and offer internships...",
      imageUrl: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-06-22",
    },
    {
      title: "Environmental Impact Initiative Update",
      content: "We’re proud to report a 30% reduction in carbon emissions across all our offices in the last year...",
      imageUrl: "https://images.unsplash.com/photo-1515777315835-281ec6cc7ccf?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-07-14",
    },
    {
      title: "Upcoming Tech Conference Participation",
      content: "Our team will be attending the global tech conference in Singapore to showcase our innovations...",
      imageUrl: "https://images.unsplash.com/photo-1562076667-45b4c128c34a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-08-01",
    },
    {
      title: "Company Hosts Charity Event for Local Schools",
      content: "We organized a charity event raising $50,000 for improving education facilities in underprivileged areas...",
      imageUrl: "https://images.unsplash.com/photo-1556742031-c6961e8560b0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-09-08",
    },
    {
      title: "Employee of the Year: Meet Sarah Johnson",
      content: "Congratulations to Sarah Johnson for being recognized as Employee of the Year for her contributions...",
      imageUrl: "https://images.unsplash.com/photo-1517841905240-472988babdf9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80",
      date: "2024-10-20",
    }
  ];
  
  module.exports = companyNews;
  